(function() {
  function init() {
    var btn = document.getElementById('tw-back-to-top');
    if (btn) {
      function toggle() { btn.classList.toggle('tw-opacity-100', window.scrollY > 400); btn.classList.toggle('tw-pointer-events-auto', window.scrollY > 400); }
      window.addEventListener('scroll', toggle);
      toggle();
      btn.addEventListener('click', function(e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }

    document.querySelectorAll('.tw-footer__heading').forEach(function(heading) {
      heading.addEventListener('click', function() {
        if (window.innerWidth < 768) {
          var block = this.closest('.tw-footer__block');
          if (!block) return;
          var isActive = block.classList.contains('is-active');

          if (!isActive) {
            block.classList.add('is-active');
          } else {
            block.classList.remove('is-active');
          }
        }
      });
    });

    document.querySelectorAll('#FooterCountryForm select[data-submit], #FooterLanguageForm select[data-submit]').forEach(function(el) {
      el.addEventListener('change', function() { this.form.submit(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
